

export const frodoReviewerReviewHinge = {
  _id: 'frodoReviewerReviewHingeId',
  email: 'frodo@email.com',
  profileReviewId: 'frodoProfileReviewHingeId',
  reviewerProfileId: 'frodoReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Frodo! This will really help me!',
  profileReviewedFirstName: 'Holly',
}

export const luigiReviewerReviewBumble = {
  _id: 'luigiReviewerReviewBumbleId',
  email: 'luigi@email.com',
  profileReviewId: 'luigiProfileReviewBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Luigi! This will really help me!',
  profileReviewedFirstName: 'Holly',
}

export const gatsbyReviewerReviewTinder = {
  _id: 'gatsbyReviewerReviewTinderId',
  email: 'gatsby@email.com',
  profileReviewId: 'gatsbyProfileReviewTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Gatsby! This will really help me!',
  profileReviewedFirstName: 'Holly',
}